import { useState, useEffect } from 'react'
import { IprAtt } from 'Ui/Components/iprAtt/IprAtt'
import { Measures } from 'Ui/Components/measures/Measures'
import { Movements } from 'Ui/Components/movements/Movements'
import { VersionHistoryPanel } from 'Ui/Components/VersionHistory/VersionHistoryPanel'
import { NotesPanel } from 'Ui/Components/VersionHistory/NotesPanel'
import { gesturesSubscribe, gesturesUnsubscribe } from 'Application/Gestures/gesturesHandler'
import 'Application/Templates/Css/Layer/SpecsDesktop.css'


/*****************************************************************
 * Footer Specifications
 * Show specific panel for Footer
 * ***************************************************************/

/**
 * Specification Component
 * @param { array } section
 * @returns JSX
 */
export const Specification = props => {

    useEffect(() => {
        gesturesSubscribe(props.specsActive)
        return () => gesturesUnsubscribe()
    }, [ props.specsActive, ])

    const
        [visible, setVisible] = useState( null ),
        getJaw = content => {
            let desc = {
                upper: ['upper'],
                lower: ['lower'],
                both: ['upper', 'lower']
            }
            return desc[content] ? desc[content] : []
        }


    useEffect(() => {
        switch(props.section){
            case 'mod':
                setVisible(null)
                break
            case 'mvt':
                setVisible(<Movements mvt={ getJaw(props.content['mvt']) } />)
                break
            case 'att':
                setVisible(<IprAtt att={ getJaw(props.content['att']) } ipr={ getJaw(props.content['ipr']) }/>)
                break
            case 'mea':
                setVisible(<Measures mea={ getJaw(props.content['mea']) }/>)
                break
            case 'hist':
                setVisible(<VersionHistoryPanel />)
                break
            case 'note':
                setVisible(<NotesPanel />)
                break
            default:
                setVisible(<div>Content unAvailable</div>)
        }
    }, [props])


    return visible
}
